<div class="announcements-area ptb-80">
  <div class="container">
    <div class="section-title">
      <h3 i18n="@@pressRoomOurBlogTitle">Our blog</h3>
      <div class="bar"></div>
    </div>
    <div class="row">
      <h4 class="font-weight-500 font-size-24" i18n="@@pressRoomVisitBlog">
        Visit our <a routerLink="/blog">blog</a> to read our latest articles.
      </h4>
    </div>
  </div>
</div>
